// components/SkeletonContainer/SkeletonContainer.tsx
import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface SkeletonContainerProps {
    /**
     * Contenu du skeleton à afficher
     */
    children: React.ReactNode;

    /**
     * Styles personnalisés pour le container
     */
    sx?: SxProps<Theme>;

    /**
     * Largeur du container
     * @default '100%'
     */
    width?: string | number;

    /**
     * Hauteur du container
     * @default '100%'
     */
    height?: string | number;

    /**
     * Centrer le contenu verticalement et horizontalement
     * @default true
     */
    centered?: boolean;
}

/**
 * Container pour encapsuler et positionner les skeletons
 *
 * @example
 * ```tsx
 * <SkeletonContainer sx={{ marginLeft: '-40px', height: '300px' }}>
 *   <SimplePanelSkeleton />
 * </SkeletonContainer>
 * ```
 */
export const SkeletonContainer: React.FunctionComponent<SkeletonContainerProps> = function ({
    children,
    sx = {},
    width = '100%',
    height = '100%',
    centered = true,
}) {
    return (
        <Box
            sx={{
                width,
                height,
                ...(centered && {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }),
                ...sx,
            }}
        >
            {children}
        </Box>
    );
};
